import React, { Component } from 'react';
import i from '../imports';
import c from '../components';
import Session from '../services/session';

const commonStyle = {
    fontSize: '24px',
    fontWeight: 'Regualar',
    paddingTop: '10px'
}

const titleStyle = {
    ...commonStyle,
    fontWeight: 'bold',
    color: '#FF5563',
    fontSize: '28px',
    paddingBottom: '10px'
}

const subTitleStyle = {
    ...commonStyle,
    fontWeight: 'bold',
    fontSize: '20px',
    textTransform: 'capitalize'
}

const textStyle = {
    align:"left",
    fontSize: "20px",
}



class ContactInformation extends Component {

    render() {
        return (
            <i.Grid container spacing={24}>
                    <i.Grid direction="column" style={{backgroundColor: "#F5F5F5", marginTop: "30px", padding:"20px"}}>
                        <i.Grid style={titleStyle} align="left">
                            {this.props.data.contacts.contacts_title}
                        </i.Grid>
                        <i.Grid align="left">
                            <div style={{height:"180px", border: "3px solid #979797"}}>
                                <c.AddressToMapComponent latitude={this.props.data.location.latitude} longitude={this.props.data.location.longitude} />
                            </div>
                        </i.Grid>
                        <i.Grid align="left">
                            <div style={subTitleStyle}>
                                {Session.model.common.words.address}:
                            </div>
                            <div style={textStyle}>
                                {this.props.data.contacts.address}
                            </div>
                            <div style={subTitleStyle}>
                                {Session.model.common.words.phone}:
                            </div>
                            {this.props.data.contacts.phones.map(m =>
                                <div style={textStyle}>
                                    {m.phone}
                                </div>
                            )}
                            <div style={subTitleStyle}>
                                {Session.model.common.words.email}:
                            </div>
                            {this.props.data.contacts.emails.map(m =>
                                <div style={textStyle}>
                                    {m.email}
                                </div>
                            )}
                        </i.Grid>
                    </i.Grid>
            </i.Grid>
        )
    }
}

export default ContactInformation;